import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private userIdentity: any;
  private authenticated = false;
  private authenticationState = new Subject<any>();

  constructor(private http: HttpClient, private auth: AuthService) {}

  async identity(force: boolean = false): Promise<any> {
    if (force) {
      this.userIdentity = undefined;
    }

    if (this.authenticated) {
      return this.userIdentity;
    } else {
      try {
        const result = await this.getIdentity();
        if (result) {
          this.userIdentity = result;
          this.authenticated = true;
          this.authenticationState.next(this.userIdentity);
          return this.userIdentity;
        } else {
          localStorage.removeItem('empresa');
          return undefined;
        }
      } catch (error) {
        console.error('Error fetching identity', error);
        return undefined;
      }
    }
  }

  async getIdentity(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.auth.user$.subscribe({
        next: user => {
          if (user) {
            if (user.sub) {
              localStorage.setItem('usuario', user.sub);
            } else {
              console.warn('User object does not have sub property:', user);
            }
            resolve(user); // Resuelve la promesa con el usuario obtenido
          } else {
            console.warn('User is null');
            resolve(null); // Resolve with null if user is null
          }
        },
        error: error => {
          console.error('Error al recuperar usuario', error);
          reject(error); // Rechaza la promesa si hay un error
        },
      });
    });
  }

  getAuthorization(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.auth.idTokenClaims$.subscribe({
        next: user => {
          resolve(user); // Resuelve la promesa con el usuario obtenido
        },
        error: error => {
          console.error('Error al recuperar usuario', error);
          reject(error); // Rechaza la promesa si hay un error
        },
      });
    });
  }

  hasAnyAuthority(authorities: string[]): Promise<boolean> {
    return Promise.resolve(this.hasAnyAuthorityDirect(authorities));
  }

  hasAnyAuthorityDirect(authorities: string[]): boolean {
    if (!this.authenticated || !this.userIdentity || !this.userIdentity.authorities) {
      return false;
    }

    for (let i = 0; i < authorities.length; i++) {
      if (this.userIdentity.authorities.includes(authorities[i])) {
        return true;
      }
    }

    return false;
  }

  hasAuthority(authority: string): Promise<boolean> {
    if (!this.authenticated) {
      return Promise.resolve(false);
    }

    return this.identity().then(
      id => {
        return Promise.resolve(id.authorities && id.authorities.includes(authority));
      },
      () => {
        return Promise.resolve(false);
      }
    );
  }

  private isAuthenticated(): boolean {
    return this.authenticated;
  }

  isIdentityResolved(): boolean {
    return this.userIdentity !== undefined;
  }

  getAuthenticationState(): Observable<any> {
    return this.authenticationState.asObservable();
  }

  getImageUrl(): string {
    return this.isIdentityResolved() ? this.userIdentity.imageUrl : null;
  }
}
